import React from "react"
import * as styles from "./usageForm.module.scss"
import axios from "axios"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import { TM } from "../../common/typography/trademark"
const Recaptcha = require("react-recaptcha")

export default class UsageForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      isVerified: false,
      recaptcha: "",
      isEmailSent: false,
      provisionid: "",
    }
  }

  getCookie(name) {
    var nameEQ = name + "="
    var ca = document.cookie.split(";")
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) == " ") c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }

  eraseCookie(name) {
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"
  }

  setCookie(name, value, days) {
    var expires = ""
    if (days) {
      var date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = "; expires=" + date.toUTCString()
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/;secure;"
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search)

    let provid = queryParams.get("provid")

    if (provid && provid.trim() !== "") {
      // url has provision_id , set cookie

      this.setCookie("prov_id", provid)
      this.setState({ provisionid: provid })
    } else {
      // url does not have provision_id , lets check cookie, perhaps re-visiting
      provid = this.getCookie("prov_id")

      if (provid && provid.trim() !== "") {
        this.setState({ provisionid: provid })
      } else {
        this.setState({ provisionid: "" })
      }
    }
  }

  recaptchaLoaded = () => {
    // console.log("recaptcha loaded")
  }

  verifyCallback = res => {
    this.setState({
      isVerified: true,
      recaptcha: res,
    })
  }

  handleChange = e => {
    const { value, name } = e.target

    this.setState({
      [name]: value,
    })
  }

  handleSubmit = e => {
    e.preventDefault()

    const template_params = {
      email: this.state.email,
      firstname: this.state.firstName,
      lastname: this.state.lastName,
      g_recaptcha_response: this.state.recaptcha,
      provisionid: this.state.provisionid,
    }

    let self = this

    let url = `${process.env.KEYSERVER_API_URL}/api/v1/installation`

    axios
      .post(url, template_params)
      .then(function(response) {
        // let results = response.data
        self.setState({ isEmailSent: true })
        self.eraseCookie("prov_id")
      })
      .catch(function(error) {
        if (error && error.response && error.response.status === 400) {
          alert(error.response.data.reason)
        } else {
          console.log(error)
        }
      })
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isEmailSent === true ? (
          <div>
            <div className={styles.columnHeader}>Installation Email Sent</div>

            <div className={styles.emailConfirmation}>
              <p className={styles.emailSent}>
                An "Installation Email" has been sent to the following address:
              </p>

              <p className={styles.emailAddress}>{this.state.email}</p>

              <div className={styles.reminder}>
                <ol>
                  <li>
                    {" "}
                    Please go the computer where you normally use to
                    send/receive emails of the above email account
                  </li>

                  <li>
                    {" "}
                    Receive/open the above-mentioned "Installation Email".
                  </li>

                  <li>
                    {" "}
                    Follow the instructions on the Installation Email and click
                    the link to proceed to install IronCAP X<TM />.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        ) : (
          <form onSubmit={this.handleSubmit} className={styles.usageForm}>
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Email"
              value={this.state.email}
              onChange={this.handleChange}
            />
            <input
              type="text"
              name="firstName"
              className="form-control"
              placeholder="First Name"
              value={this.state.firstName}
              onChange={this.handleChange}
            />
            <input
              type="text"
              name="lastName"
              className="form-control"
              placeholder="Last Name"
              value={this.state.lastName}
              onChange={this.handleChange}
            />
            <p>
              By clicking below, I agree to the{" "}
              <OutboundLink
                href="https://www.01com.com/pdf/ironcapx-terms-of-service.pdf"
                target="_blank"
              >
                Terms{" "}
              </OutboundLink>
              and{" "}
              <OutboundLink
                href="https://www.01com.com/pdf/ironcap-privacy-policy.pdf"
                target="_blank"
              >
                Privacy Policy.
              </OutboundLink>{" "}
              An email will be sent to the above address with a link to install
              IronCAP X<TM />.
            </p>
            <div className={styles.recaptchaWrapper}>
              <Recaptcha
                sitekey="6LeoUJ8UAAAAAEABtDiHsascEeo4WOMiG-47E07j"
                onloadCallback={this.recaptchaLoaded}
                verifyCallback={this.verifyCallback}
                render="explicit"
                async="false"
                defer="false"
                data-size="compact"
              />
            </div>

            <button
              type="submit"
              disabled={!this.state.isVerified}
              className={
                this.state.isVerified ? styles.verified : styles.unverified
              }
            >
              Send Installation Email
            </button>
          </form>
        )}
      </React.Fragment>
    )
  }
}
